import { Box, styled } from '@mui/material';

export const Header = styled(Box)(() => ({
  display: 'flex',
}));

export const Container = styled(Box)({
  width: '100%',
});
